import { useEffect, useState } from "react"
import { Tag, Modal } from "antd"
import { ajaxFetchCall } from "../../services/ApiService"
import { backendUrl } from "../../Config"
import { useNavigate } from "react-router"
import "./home.css"
let colors = ["magenta", "red", "volcano", "orange", "gold", "lime", "green", "cyan", "blue", "geekblue", "purple"]


export default function Home(props) {
    const [modal, contextHolder] = Modal.useModal();
    const [allFav, setAllFav] = useState([])
    const navigate = useNavigate();
    useEffect(() => {
        getAllFav()
    }, [])


    const getAllFav = async () => {
        let allFav = await ajaxFetchCall(backendUrl + "/user/fav")
        setAllFav(allFav["response"])
    }

    const onClose = async (id) => {
        let allFav = await ajaxFetchCall(backendUrl + "/user/fav/" + id, {
            method: "DELETE"
        })
        getAllFav()
    }

    const onClick = (url) => {
        navigate(url)
    }

    const getFav = () => {
        let favs = []
        let i = 0;
        for (let l of allFav) {
            i++
            favs.push(

                <div key={l._id}>
                    <Tag
                        className="tile"
                        key={l._id}
                        closable
                        onClose={(e) => {
                            Modal.confirm({
                                title: 'Are you sure to delete ' + l.name,
                                onOk() { onClose(l._id) },
                            });
                            e.preventDefault()
                        }
                        }
                        onClick={() => {
                            onClick(l.url)
                        }
                        }
                        color={colors[Math.floor(Math.random() * colors.length)]} > {l["name"]}
                    </Tag >
                </div >
            )
        }
        return favs
    }

    return <div className="tile-wrapper">
        {getFav()}
    </div>
}